/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { FC } from 'react'
import { NumericTextBox } from '@progress/kendo-react-inputs'
import {
  Card,
  CardBody,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import { Label } from '@progress/kendo-react-labels'
import { SimulationCalculationInfoResItem } from '@gateway.Simulation'
export interface ExpenseInformationProps {
  workYamadumi: SimulationCalculationInfoResItem
  isReadonlyDisabled: boolean
  onChange: (id: string, value: number | null) => void
}
export const ExpenseInformationTypeE: FC<ExpenseInformationProps> = React.memo(({
  workYamadumi,
  isReadonlyDisabled,
  onChange
}) => {
  return (
    <Card>
      <CardBody>
        <GridLayout gap={{ cols: 10 }}>
          <GridLayoutItem col={1}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>坪単価（{workYamadumi.unit1}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  value={workYamadumi?.costPerTsubo ?? undefined}
                  onChange={
                    (event) => onChange('costPerTsubo', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={2}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>定数</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '60px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 3 }}
                  value={workYamadumi?.constant ?? undefined}
                  onChange={
                    (event) => onChange('constant', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={3}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>安全率</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '60px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 3 }}
                  value={workYamadumi?.safeRatio ?? undefined}
                  onChange={
                    (event) => onChange('safeRatio', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={4}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>労務比率（{workYamadumi.unit2}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.workRatioFinish ?? undefined}
                  onChange={
                    (event) => onChange('workRatioFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={5}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>労務単価（{workYamadumi.unit3}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  value={workYamadumi?.costPerWork ?? undefined}
                  onChange={
                    (event) => onChange('costPerWork', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={6}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>全体予定({workYamadumi.unit7})数（{workYamadumi.unit4}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  disabled
                  value={workYamadumi?.scheduledWorkAll ?? undefined}
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={7}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[{ height: '2.0em' }, { height: '1.5em' }]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>工期比率（{workYamadumi.unit5}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1} colSpan={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleRatioFinish ?? undefined}
                  onChange={
                    (event) => onChange('scheduleRatioFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={8}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>予定({workYamadumi.unit7})数（{workYamadumi.unit6}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  value={workYamadumi?.scheduledWorkFinish ?? undefined}
                  onChange={
                    (event) => onChange('scheduledWorkFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        </GridLayout>
      </CardBody>
    </Card>
  )
})
